import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/lib/site";
import { trackPageview } from "@/lib/analytics";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

const AnalyticsTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageview();
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App grain">
      <SiteProvider>
        <BrowserRouter>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/terms" element={<Legal page="terms" />} />
            <Route path="/privacy" element={<Legal page="privacy" />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/:lpSlug" element={<LandingPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </SiteProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
